<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load">
          <b-col lg="4" sm="12" class="text-left">
            <Lg-Finder-Page-Unidade-Administrativa v-model="form.unidadeAdministrativa" id="finderunidadeAdministrativa"
              @onselect="handleSelectUnidadeAdministrativa" invalidFeedback="Unidade administrativa deve ser informada!"
              description="Selecione a unidade administrativa">
            </Lg-Finder-Page-Unidade-Administrativa>
          </b-col>

          <lg-form-const-select lg="4" sm="4" label="Situação:" v-model="form.situacao" :options="optionsFilterSituacao"
            @change="load" />

          <lg-form-input lg="4" sm="4" v-model="form.nomeUsuario" description=" " label="Nome do Usuário:"
            placeholder="Nome do usuário" />

          <b-col lg="4" sm="12" class="text-left">
            <lg-finder-page-usuario :prefix="prefix + title + ' > '" id="finderResponsavelAssociacaoPerfil"
              @onselect="handleUsuarioResponsavelSelect" label="Responsável:"
              invalidFeedback="Responsável deve ser informado!" v-model="form.responsavel"
              description="Selecione o responsável">
            </lg-finder-page-usuario>
          </b-col>


          <b-col lg="4" sm="12" class="text-left">
            <lg-finder-page-usuario :prefix="prefix + title + ' > '" id="finderUsuarioAssociacaoPerfilUsuario" @onselect="handleUsuarioSelect"
              v-model="form.usuario" invalidFeedback="Usuário deve ser informado!" description="Selecione o usuário">
            </lg-finder-page-usuario>
          </b-col>

          <lg-form-input lg="4" sm="4" v-model="form.login" description=" " label="Login do Usuário:"
            placeholder="Login do usuário" />


          <b-col lg="4" sm="12" class="text-left">
            <lg-finder-page-perfil :prefix="prefix + title + ' > '" @onselect="handleUsuarioPerfilSelect"
              v-model="form.perfil" id="finderPerfialAssociacao" invalidFeedback="Perfil deve ser informado!"
              description="Selecione o perfil">
            </lg-finder-page-perfil>
          </b-col>



          <lg-form-const-select lg="4" sm="4" label="Sistema:" v-model="form.sistema" :options="optionsFilterSistema"
            @change="load" />

          <lg-form-const-select lg="4" sm="4" labelFormGroupBind="Módulo:" label="Módulo:" v-model="form.modulo"
            :options="optionsFilterModulo" @change="load" />
        </b-form-row>

        <b-form-row>
          <b-col lg="12" sm="12" class="text-right">
            <b-button id="limpar" class="my-2" size="sm" style="height: 20px" pill variant="primary" @click="clearForm">
              <div class="btn-size-alinhamento">
                <b-icon icon="eraser" />
              </div>
              <b-tooltip target="limpar" title="Limpar"></b-tooltip>
            </b-button>

            <b-button id="localizar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
              @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="localizar" title="Localizar"></b-tooltip>
            </b-button>


            <b-button id="adicionarAPU" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
              @click="abrirModal">
              <div class="btn-size-alinhamento">
                <b-icon icon="plus" />
              </div>
              <b-tooltip target="adicionarAPU" title="Adicionar novo"></b-tooltip>
            </b-button>

          </b-col>
        </b-form-row>
      </b-card>

      <b-card bg-variant="light">
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" show-empty>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #empty>
            <p>
              Nenhum registro encontrado
            </p>
          </template>

          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'apu-ativar'">
              <b-form-checkbox v-model="row.item.situacao" switch :value="1" :unchecked-value="0"
                @change="alteraSituacao(row.item)" />
              <b-tooltip :target="row.index + 'apu-ativar'" title="Ativar/Desativar..."></b-tooltip>
            </div>
          </template>



          <template v-slot:cell(editar)="row">
            <b-button :id="row.index + 'edit-apu-button'" class="my-2" size="sm" pill variant="primary"
              @click="abrirModal(row.item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="row.index + 'edit-apu-button'" title="Editar..."></b-tooltip>
            </b-button>
          </template>


          <template v-slot:cell(visualizar)="row">
            <b-button :id="row.index + 'visualizar-apu-button'" class="my-2" size="sm" pill variant="primary"
              @click="visualizar(row.item)">
              <b-icon icon="eye" />
              <b-tooltip :target="row.index + 'visualizar-apu-button'" title="Visualizar..."></b-tooltip>
            </b-button>
          </template>


        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <AssociacaoPerfilUsuarioForm :isVisualizar="isVisualizar" :prefix="prefix + title + ' > '" :id="id" v-if="showModal" @close="cancelar"></AssociacaoPerfilUsuarioForm>
  </b-card>
</template>

<script>
import LgFinderPagePerfil from "@/components/Finders/LgFinderPagePerfil.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageUsuario from "@/components/Finders/LgFinderPageUsuario.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import AssociacaoPerfilUsuarioForm from "./AssociacaoPerfilUsuarioForm.vue";
import ConfirmMixin from "@/core/mixins/confirm"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    LgFinderPagePerfil,
    LgFinderPageUsuario,
    LgFinderPageUnidadeAdministrativa,
    AssociacaoPerfilUsuarioForm
  },
  props: {
    prefix: {
      type: String,
      default: "",
    },

  },
  data() {
    return {
      isVisualizar: false,
      id: null,
      showModal: false,
      title: 'Associação Perfil Usuário',
      params: {},
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: {},
      form: {

        nomeUsuario: "",
        login: "",
        unidadeAdministrativa: {},

        responsavel: {},

        perfil: {},

        usuario: {},

        sistema: null,
        modulo: null,

        situacao: "1",

      },
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
      optionsFilterModulo: [
        { key: "filterModulo1", text: "Almoxarifado ", value: "3" },
        { key: "filterModulo2", text: "Coletor RFID ", value: "8" },
        { key: "filterModulo3", text: "Patrimonio ", value: "4" },
        { key: "filterModulo4", text: "Principal ", value: "6" },
      ],

      optionsFilterSistema: [
        { key: "filterSistema", text: "SGU", value: "1" },
        { key: "filterSistema", text: "SPALM", value: "2" },
      ],

    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],

  beforeMount() {
    this.$service = new ResourceService(`/api/sgu/usuarios/${0}/perfis`);
  },

  mounted() {
    this.load();
  },

  watch: {
    page() {
      this.load();
    },

  },

  computed: {

    tableFields() {
      return [
        {
          key: "usuarioResponsavel.nome",
          label: "Responsável",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "usuario.nome",
          label: "Usuário",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "usuario.login",
          label: "Login do usuário",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "perfil.perfil",
          label: "Perfil",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "modulo.sistema.nome",
          label: "Sistema",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "modulo.descricao",
          label: "Módulo",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "departamento.nome",
          label: "Unidade Administrativa",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "editar",
          label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "visualizar",
          label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "situacao",
          label: " ",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },

      ];
    },
  },

  methods: {
    
    visualizar(item) {
      this.isVisualizar = true;
      if (item)
        this.id = item.id;
      this.showModal = true;
    },

    abrirModal(item) {
      if (item)
        this.id = item.id;
      this.showModal = true;
    },
    cancelar() {
      this.id = null;
      this.showModal = false;
      this.isVisualizar = false;
      this.load();
    },
    async load() {
      this.params = {
      };


      if (this.form.unidadeAdministrativa && this.form.unidadeAdministrativa.id) {
        this.params.departamento = this.form.unidadeAdministrativa.setorId;
      }

      if (this.form.situacao != null) {
        this.params.situacao = this.form.situacao;
      }

      if (this.form.nomeUsuario && this.form.nomeUsuario.length > 0) {
        this.params.nome = this.form.nomeUsuario;
      }

      if (this.form.login && this.form.login.length > 0) {
        this.params.login = this.form.login;
      }



      if (this.form.modulo) {
        this.params.modulo = this.form.modulo;
      }

      if (this.form.sistema) {
        this.params.sistema = this.form.sistema;
      }

      if (this.form.perfil && this.form.perfil.id) {
        this.params.perfil = this.form.perfil.id;
      }

      if (this.form.responsavel && this.form.responsavel.id) {
        this.params.usuario = this.form.responsavel.id;
      }


      if (this.form.usuario && this.form.usuario.id) {
        this.params.usuario = this.form.usuario.id;
      }

      if (this.form.situacao != undefined) {
        this.params.situacao = this.form.situacao;
      }

      this.busy = true;
      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: this.params,
        isOrOperation: "false",
      });
    },

    clearForm() {
      this.form = {

        nomeUsuario: "",
        login: "",
        unidadeAdministrativa: {},

        responsavel: {},

        perfil: {},

        usuario: {},

        sistema: null,
        modulo: null,

        situacao: "1",

      }
      this.load();
    },

    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Associação Perfil Usuário?"
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },



    async handleSelectModulo(modulo) {
      this.form.modulo = modulo;
      this.load();
    },

    async handleSelectUnidadeAdministrativa(unidadeAdministrativa) {
      this.form.unidadeAdministrativa = unidadeAdministrativa;
      this.load();

    },

    async handleUsuarioSelect(item) {
      this.form.usuario = item;
      this.load();

    },
    async handleUsuarioResponsavelSelect(item) {
      this.form.responsavel = item;
      this.load();

    },

    async handleUsuarioPerfilSelect(item) {
      this.form.perfil = item;
      this.load();

    },
    async handleSelectPerfil(perfil) {
      this.form.perfil = perfil;
      this.load();

    },
  },
};
</script>
